



















import { defineComponent, type PropType } from "vue-demi";
import type { DataSourceResponse } from "@constructor/shared-entity/type";
import { format, parse } from "date-fns";
import { ru } from "date-fns/locale";
import striptags from "striptags";

export default defineComponent({
  name: "FCSale",
  props: {
    data: {
      type: Object as PropType<DataSourceResponse>,
      default: () => ({}),
    },
  },
  computed: {
    description() {
      return this.sale?.preview ? striptags(this.sale.preview) : null;
    },
    sale() {
      return this.data?.sale?.[0];
    },
  },
  methods: {
    getDate(date: string) {
      return format(
        parse(date.split(" ")[0], "dd.MM.yyyy", new Date(), { locale: ru }),
        "d MMMM",
        { locale: ru }
      );
    },
  },
});
